module.exports = __webpack_public_path__ + "img/ru.6e00747f.svg";